import { useMemo, useState } from 'react'
import { img } from '../../../assets/assets'
import { useTypedSelector } from '../../../hooks/useTypedSelector'
import { ICard } from '../../../types/card'
import { removeToken } from '../../../utils/lot'
import { Popup } from '../../../hoc/Popup'
import { useRedirect } from '../../../hooks/useRedirect'
import { Share } from '../Share'
// import { useContext } from 'react'
// import { EventContext } from '../../../ctx/event'
import { IconButton, IconButtons, IconMenu, IconMenuButton } from '../Buttons'
import { Editor } from './Editor'
import { UpdateTimer } from '../Timer'
import { useCardMeta } from '../../../hooks/useCardMeta'
import { createConfigWithEnvType } from '../../../utils/wallet/metamask/methods'

export interface CardInfo {
    card: ICard
}
export const CardIconButtons = ({ card }: CardInfo) => {
    const { auth } = useTypedSelector((store) => store)
    const [showEditor, setShowEditor] = useState(false)
    const [showShare, setShowShare] = useState(false)
    const [showSetTimer, setShowTimer] = useState(false)
    const redirect = useRedirect()
    // const { onCardUpdated } = useContext(EventContext)
    const {
        isLot,
        isAuthor,
        isDraft,
        isBan,
        isOriginalToken,
        showShareBtn,
        canSetNewTimer,
    } = useCardMeta(card)

    const nftToken = useMemo(
        () => card.TokensNFT?.find((t) => t.userId === auth.id),
        [card, auth]
    )

    // function updated() {
    //     setShowEditor(false)
    //     if (onCardUpdated) onCardUpdated()
    // }
    async function remove() {
        await removeToken(card.id)
        redirect.toIndex()
    }
    function toBsc() {
        if (!nftToken) return
        window.open(
            `https://bscscan.com/token/${
                createConfigWithEnvType().main.addresses.factory
            }?a=${nftToken.token}`,
            '_blank'
        )
    }
    return (
        <>
            <IconButtons>
                {nftToken ? (
                    <IconButton handler={toBsc}>
                        <img src={img.externalLink} alt="" />
                    </IconButton>
                ) : null}
                {isAuthor && isDraft ? (
                    <IconMenu>
                        <IconMenuButton
                            title="edit"
                            handler={() => setShowEditor(!showEditor)}
                        >
                            <i className="fas fa-edit"></i>
                        </IconMenuButton>
                    </IconMenu>
                ) : null}
                {canSetNewTimer ? (
                    <IconMenu>
                        <IconMenuButton
                            title="Edit timer"
                            handler={() => setShowTimer(true)}
                        >
                            <i className="fas fa-edit"></i>
                        </IconMenuButton>
                    </IconMenu>
                ) : null}
                {isOriginalToken && (isBan || isDraft) ? (
                    <IconButton handler={remove}>
                        <i className="fas fa-trash"></i>
                    </IconButton>
                ) : null}
                {showShareBtn ? (
                    <IconButton handler={() => setShowShare(!showShare)}>
                        <img src={img.shareIcon} alt="" />
                    </IconButton>
                ) : null}
            </IconButtons>

            <Popup showState={[showEditor, setShowEditor]} title="Edit NFT">
                <Editor card={card}></Editor>
            </Popup>
            <Share
                show={[showShare, setShowShare]}
                link={`${isLot ? '/lot/' : '/original-token/'}${card.id}`}
            ></Share>
            <UpdateTimer
                state={[showSetTimer, setShowTimer]}
                lotId={card.id}
            ></UpdateTimer>
        </>
    )
}
